// extracted by mini-css-extract-plugin
export default {"selectPanelButton":"use-select-panel-props-module__selectPanelButton--U_ekr"};